import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';
import { D as DeprecationLogger } from './p-c44c2366.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSubtitlesFilledStyle0 = cosmosIconCss;

const CosmosIconSubtitlesFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSubtitlesFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.logger = new DeprecationLogger('cosmos-icon-subtitles-filled', {
            'cosmos-icon-subtitles-filled': {
                type: 'component',
                message: 'This component is deprecated and will be removed with the next major release end of Q4.',
                resolveDate: 'Q4, 2024',
            },
        });
        this.ariaLabel = undefined;
    }
    componentDidLoad() {
        this.logger.warnComponent();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e222fa3e38251b4884c76e4603250cb26fc931f0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '43b3203f5d019496eeccfd422de298f2fbec419b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '79e3f14ecf93a6ad2e02d628b8c4f5e2e865f20f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 4h-17c-.276 0-.5.241-.5.538v12.924c0 .297.224.538.5.538h17c.276 0 .5-.241.5-.538V4.538c0-.297-.224-.538-.5-.538Zm-1 1.5v11h-15v-11h15Zm-14 10v-9h13v9h-13Zm8.5-2.25a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5Zm1.5-2.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h7Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSubtitlesFilledStyle0; }
}, [1, "cosmos-icon-subtitles-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-subtitles-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-subtitles-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSubtitlesFilled$1);
            }
            break;
    } });
}

const CosmosIconSubtitlesFilled = CosmosIconSubtitlesFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSubtitlesFilled, defineCustomElement };
